import { SYNC_PROGRESS_UPDATE, SYNC_PROGRESS_RESET } from '../Actions/SyncProgressAction';

const initialState = {
    progress: 0,
};

const SyncProgressReducer = (state = initialState, action) => {
    switch (action.type) {
        case SYNC_PROGRESS_UPDATE:
            return {
                ...state,
                progress: action.payload,
            };
        case SYNC_PROGRESS_RESET:
            return initialState;
        default:
            return state;
    }
};

export default SyncProgressReducer;
